import { render, staticRenderFns } from "./GLBalance.vue?vue&type=template&id=12066f25&"
import script from "./GLBalance.vue?vue&type=script&lang=js&"
export * from "./GLBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports